import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Link, Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from 'antd';
import ReactPaginate from "react-paginate";
import { useFormik } from "formik";
import { toast } from 'react-toastify';
import { BeatLoader } from 'react-spinners';
import { Table } from "antd";

import { getContractInfoAdmin, getCustomerContractListAdmin, getCustomerDataAdmin, getCustomerList } from "../../Redux/action/Admin/CustomerAction";
import { adminMainUrl } from "../../Config.jsx";
import Beatloader from "../../Common/Loaders/Beatloader.jsx";
import { DDMMMYYYYformateDate } from "../../HelperFunctions.js";
import EditContract from "./Contract/EditContract.jsx";
import ViewContract from "./Contract/ViewContract.jsx";
import ApprovalDisapprovalContractModal from "./Contract/ApprovalDisapprovalContractModal.jsx";
import RenewalModal from "./RenewalModal.jsx";

const CustomerContractList = ({ accessedPermission }) => {
    const [grid, setGrid] = useState(true);
    const { b64id } = useParams();
    const [showLoader, setShowLoader] = useState(true);
    const token = Cookies.get('token');


    useEffect(() => {
        if (!token) {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        } else {
            if (!b64id) {
                toast.error("Please enter url");
                navigate(-1);
            } else {
                dispatch(getCustomerDataAdmin(atob(b64id)))
                dispatch(getCustomerContractListAdmin(atob(b64id)))
            }
        }
    }, [token, b64id]);

    const refresh = () => {
        if (token && b64id) {
            dispatch(getCustomerDataAdmin(atob(b64id)))
            dispatch(getCustomerContractListAdmin(atob(b64id)))
        }
    }


    let {
        loadingCustomerData,
        CustomerDataError,
        CustomerData,

        loadingCustomerContractListAdminData,
        CustomerContractListAdmin,
        CustomerContractListAdminError,

        loadingContractInfoAdmin,
        ContractInfoAdmin,
        ContractInfoAdminError,

    } = useSelector(state => state?.CustomerReducer);


    useEffect(() => {
        if (loadingCustomerData) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
    }, [loadingCustomerData, CustomerData])



    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Unique ID", dataIndex: "unique_id", key: "unique_id" },
        { title: "Document Type", dataIndex: "document_type", key: "document_type" },
        { title: "Approval Status", dataIndex: "approval_status", key: "approval_status" },
        { title: "Contract Start Date", dataIndex: "start_date", key: "start_date" },
        { title: "Contract End Date", dataIndex: "end_date", key: "end_date" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];


    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const page_no = queryParams.get("page");
    const [list, setList] = useState([]);
    const [currentPage, setCurrentPage] = useState(null); // Pages are 1-indexed

    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    const [contract_id, setContract_id] = useState("");

    useEffect(() => {
        if (contract_id) {
            dispatch(getContractInfoAdmin(contract_id));
        }
    }, [contract_id])


    const [approvalshow, setApprovalShow] = useState(false);
    const handleApprovalClose = () => setApprovalShow(false);

    const handleApprovalShow = (id) => {
        setContract_id(id);
        setApprovalShow(true);
    };

    const [editContractShow, setEditContractShow] = useState(false);
    const handleEditContractClose = () => setEditContractShow(false);
    const handleEditContractShow = (id) => {
        setContract_id(id);
        setEditContractShow(true);
    };

    const [viewContractShow, setViewContractShow] = useState(false);
    const handleViewContractClose = () => setViewContractShow(false);
    const handleViewContractShow = (id) => {
        setContract_id(id);
        setViewContractShow(true);
    };

    const [viewRenewalShow, setViewRenewalShow] = useState(false);
    const handleViewRenewalClose = () => setViewRenewalShow(false);
    const handleViewRenewalShow = (id) => {
        setContract_id(id);
        setViewRenewalShow(true);
    };


    useEffect(() => {
        const page = page_no ? parseInt(page_no) : 1;
        setCurrentPage(page);
    }, [page_no]);


    const [dataSource, setDataSource] = useState([]);

    const giveApprovalStatus = (id) => {
        if (id) {
            if (id == 0) { return "PENDING" }
            else if (id == 1) { return "APPROVED" }
            else if (id == 2) { return "REJECTED" }
            else { return "PENDING" }
        } else {
            return "PENDING"
        }
    };


    useEffect(() => {
        if (CustomerContractListAdmin) {
            let arr = [];
            CustomerContractListAdmin.map((val, index) => {
                arr.push({
                    SNo: index + 1,
                    unique_id: val?.contract_unique_id,
                    document_type: val?.document_type,
                    approval_status: giveApprovalStatus(val?.approval_status),
                    start_date: val?.contract_date ? DDMMMYYYYformateDate(val?.contract_date) : "-",
                    end_date: val?.contract_expiry_date ? DDMMMYYYYformateDate(val?.contract_expiry_date) : "-",
                    action: (
                        <div className="dropdown table-action" key={index + 1}>
                            <Link
                                to="#"
                                className="action-icon"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                            >
                                <i className="fa fa-ellipsis-v"></i>
                            </Link>
                            <div
                                className="dropdown-menu dropdown-menu-right"
                                style={{
                                    position: "absolute",
                                    inset: "0px auto auto 0px",
                                    margin: "0px",
                                    transform: "translate3d(-99.3333px, 35.3333px, 0px)",
                                }}
                                data-popper-placement="bottom-start"
                            >
                                {/* <button className="dropdown-item edit-popup" onClick={() => { handleEditContractShow(val?.id) }}>
                                    <i className="fas fa-edit text-blue me-1"></i> Edit
                                </button> */}
                               {accessedPermission.includes("customer_contract_view")&& <button className="dropdown-item edit-popup" onClick={() => { handleViewContractShow(val?.id) }}>
                                    <i className="fa-regular fa-eye text-blue me-1"></i> View
                                </button>}
                                {accessedPermission.includes("customer_contract_approval") && (val?.approval_status == 0 && val?.document_type != "Renewal Contract") && <button className="dropdown-item edit-popup" onClick={() => { handleApprovalShow(val?.id) }}>
                                    <i className="fa-regular fa-thumbs-up text-blue me-1"></i> Approve/Reject
                                </button>}
                                {accessedPermission.includes("customer_contract_approval") && (val?.request_status == 1) && val?.document_type == "Renewal Contract" && <button className="dropdown-item edit-popup" onClick={() => { handleViewRenewalShow(val?.id) }}>
                                    <i className="fa-solid fa-file-contract text-blue me-1"></i> Renew Contract
                                </button>}
                            </div>
                        </div>
                    ),
                });
            });
            setDataSource(arr);
        }
    }, [CustomerContractListAdmin])


    //search and filter data

    const parseQueryParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            search_by: params.get("search_by") || "",
            emply_id: params.get("emply_id") || "",
            emply_name: params.get("emply_name") || "",
            department: params.get("department") || "",
            designation: params.get("designation") || "",
            contact_number: params.get("contact_number") || "",
            contact_email: params.get("contact_email") || "",
        };
    };

    let formik = useFormik({
        initialValues: parseQueryParams(),
        onSubmit: (values) => {
            const params = new URLSearchParams(location.search);
            Object.keys(values).forEach((key) => {
                if (values[key]) {
                    params.set(key, values[key]);
                } else {
                    params.delete(key);
                }
            });

            if (!params.has("page")) {
                params.set("page", "1");
            } else {
                params.set("page", "1");
            }
            const queryString = params.toString();
            navigate(`${location.pathname}?${queryString}`);
            // const currentPage = params.get('page') || 1;
            const currentPage = 1;
            const ITEMS_PER_PAGE = 10;
            dispatch(getCustomerList(currentPage, ITEMS_PER_PAGE, queryString));
        },
    });


    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className="content">
                            <div className="row">
                                <div className="col-md-12">
                                    {/* Page Header */}
                                    <div className="page-header">
                                        <div className="row align-items-center">
                                            <div className="col-8">
                                                <h4 className="page-title">
                                                    Customer Contacts List <span className="count-title">{1}</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    {/* /Page Header */}
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="d-flex gap-2">
                                            <label htmlFor="">Customer Name:</label>
                                            <p>{CustomerData?.name}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                    {/* Search */}
                                    <form onSubmit={formik.handleSubmit}>
                                        <div className="row align-items-center">
                                            <div className="col-sm-4">
                                                <div className="icon-form mb-3 mb-sm-0">
                                                    <span className="form-icon">
                                                        <i className="ti ti-search" />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        id="search_by"
                                                        name="search_by"
                                                        className="form-control"
                                                        placeholder="Search"
                                                        value={formik.values.search_by}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    {/* /Search */}
                                </div>
                                <div className="card-body">
                                    {/* Filter */}
                                    {
                                        <div className="table-responsive custom-table">

                                            <Table className="table datanew dataTable no-footer" pagination={false}
                                                rowSelection={false} dataSource={dataSource} columns={columns} />
                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
            }

            <EditContract
                show={editContractShow}
                handleClose={handleEditContractClose}
                ContractInfo={ContractInfoAdmin}
                contract_id={contract_id}
                loadingContractInfo={loadingContractInfoAdmin}
                CustomerProfileData={CustomerData}
            />

            <ViewContract
                show={viewContractShow}
                handleClose={handleViewContractClose}
                ContractInfo={ContractInfoAdmin}
                contract_id={contract_id}
                loadingContractInfo={loadingContractInfoAdmin}
                CustomerProfileData={CustomerData}
            />

            <ApprovalDisapprovalContractModal
                show={approvalshow}
                handleClose={handleApprovalClose}
                ContractInfo={ContractInfoAdmin}
                contract_id={contract_id}
                refresh={refresh}
                CustomerProfileData={CustomerData}
            />

            <RenewalModal
                show={viewRenewalShow}
                handleClose={handleViewRenewalClose}
                refresh={refresh}
                contract_id={contract_id}
                CustomerProfileData={CustomerData}
                ContractInfo={ContractInfoAdmin}
                loadingContractInfoAdmin={loadingContractInfoAdmin}
            />
        </>

    )
}

export default CustomerContractList